import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

// const attribute = {
//   MIN: 0,
//   MAX: 10,
//   STEP: 1
// };

const RangeInput = (props) => {
  const { id, type, typeName, order, input: { onChange }, options, required } = props;

  const [value, setValue] = useState(0);
  const [attribute, setAttribute] = useState({ MIN: 0, MAX: 10, STEP: 1 });

  useEffect(() => {
    let defaultValue;
    const newAttribute = { ...attribute };

    if (options?.length > 0) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].default) {
          defaultValue = options[i]?.value;
        }
        if (options[i].typeName === 'MIN') {
          newAttribute['MIN'] = options[i].value;
        }
        if (options[i].typeName === 'MAX') {
          newAttribute['MAX'] = options[i].value;
        }
        if (options[i].typeName === 'STEP') {
          newAttribute['STEP'] = options[i].value;
        }
      }
    }

    setAttribute(newAttribute);

    // If no default value is set then assign min value
    // REMARK: Zero(0) value is NOT NULL VALUE, zero is the same as any other number value
    if (defaultValue == null) {
      // TODO: Set to MIN or always to 0? For further discussion with business
      setValue(newAttribute['MIN']);
      // TODO: How to treat with REQUIRED and default value?
      // Since it has value and it required to have a default value 
      // then THE NEXT question will ba available\shown despite susbscriber hasn't answered yet
      // For now subscriber MUST at least to click to it, even for zero, if it has now default value
      // no matter does it change the VALUE or not, just click is enough, 
      // by default range is set to min but has NULL value, if it's required and now def value youc can set to zero by clicking to it
      // if it is OK to show next question for this case? then just remove the if statement below
      // * REMARK: Zero (0) already can be a default value, then it's treated as any other NOT NULL VALUE
      if (!required) {
        // onChange(newAttribute['MIN']);
        onChange({
          id,
          typeName,
          order,
          result: newAttribute['MIN']
        });
      }
      // if it has default value then set to store and input field value
    } else {
      setValue(defaultValue);
      // onChange(defaultValue);
      onChange({
        id,
        typeName,
        order,
        result: defaultValue
      });
    }

  }, []);

  const changeHandler = (event) => {
    // console.log(event);
    setValue(+event.target.value);
    // onChange(+event.target.value);
    onChange({
      id,
      typeName,
      order,
      result: +event.target.value
    });
  };

  return (
    // <label key={props.id}>
    <Box sx={{ width: 250 }}>
      <Slider
        value={value}
        min={attribute['MIN']}
        step={attribute['STEP']}
        max={attribute['MAX']}
        // scale={calculateValue}
        // getAriaValueText={valueLabelFormat}
        // valueLabelFormat={valueLabelFormat}
        onChange={changeHandler}
        valueLabelDisplay="auto"
        aria-labelledby="non-linear-slider"
      />
    </Box>
    // </label>
  )

  // return (
  //   <label key={props.id}>
  //     <input
  //       type="range"
  //       id="cowbell"
  //       name="cowbell"
  //       min={attribute['MIN']}
  //       max={attribute['MAX']}
  //       step={attribute['STEP']}
  //       value={value}
  //       onChange={event => changeHandler(event)}
  //       onClick={event => changeHandler(event)}
  //     />
  //     {props.label}
  //   </label>
  // );
}

export default RangeInput;